import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../styles/adminwithdraws.css";
class AdminWithdraws extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: []
    };
  }

  componentDidMount() {
    this.loadData();
  }


  loadData = async () => {
    const res = await fetch("https://api.hi-bigame.online/admin/withdraws");
    const data = await res.json();
    this.setState({ list: data });
  };


  approve = async (id) => {
    await fetch("https://api.hi-bigame.online/admin/approve-withdraw/" + id, { method: "POST" });
    this.loadData();
  };


  reject = async (id) => {
    await fetch("https://api.hi-bigame.online/admin/reject-withdraw/" + id, { method: "POST" });
    this.loadData();
  };


  render() {
    return (
      <div>
        <div className="admin-withdraw-container">

          <h1 className="admin-withdraw-title">💸 Withdraw Requests</h1>

          <button className="admin-withdraw-back" onClick={() => this.props.navigate("/admin-dashboard")} > Back </button>

          <div className="table-wrapper">

            <table className="withdraw-table">

              <thead>
                <tr>  <th>ID</th>  <th>User</th>  <th>Amount</th>  <th>Action</th> </tr>
              </thead>

              <tbody>
                {this.state.list.map((item) => (
                  <tr key={item.id}>

                    <td>{item.id}</td>
                    <td>{item.user_id}</td>
                    <td>₹{item.amount}</td>

                    <td className="action-cell">

                      <button className="approve-btn" onClick={() => this.approve(item.id)} >  Approve </button>

                      <button className="reject-btn" onClick={() => this.reject(item.id)} >  Reject </button>

                    </td>

                  </tr>
                ))}
              </tbody>

            </table>

          </div>

        </div>          
      </div>
    );

  }

}

export default withNavigation(
  AdminWithdraws
);